module.exports = __webpack_public_path__ + "img/taili(2).9ef96add.jpg";